<div class="page-wrapper">
  <!-- Decorative corner -->
  <svg
    class="deco-corner"
    viewBox="0 0 300 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <line
      x1="300"
      y1="0"
      x2="0"
      y2="280"
      stroke="rgba(59,31,163,.08)"
      stroke-width="1"
    />
    <line
      x1="300"
      y1="60"
      x2="60"
      y2="280"
      stroke="rgba(59,31,163,.06)"
      stroke-width="1"
    />
    <line
      x1="300"
      y1="120"
      x2="120"
      y2="280"
      stroke="rgba(59,31,163,.05)"
      stroke-width="1"
    />
    <path
      d="M300 280 L300 80 Q300 20 240 20 L160 20 Q80 20 40 100 Q0 180 0 280 Z"
      fill="url(#cornerGrad)"
      opacity=".9"
    />
    <defs>
      <linearGradient
        id="cornerGrad"
        x1="300"
        y1="0"
        x2="0"
        y2="280"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0%" stop-color="#3b1fa3" />
        <stop offset="55%" stop-color="#e0185c" />
        <stop offset="100%" stop-color="#f97316" stop-opacity=".7" />
      </linearGradient>
    </defs>
  </svg>

  <div class="page-container">
    <!-- TOPBAR -->
    <header class="topbar">
      <!-- <div class="logo-area">
        <svg class="logo-mark" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="38" height="38" rx="10" fill="url(#logoGrad)"/>
          <path d="M10 27V11l8 11V11M22 11l6 8-6 8" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          <defs>
            <linearGradient id="logoGrad" x1="0" y1="0" x2="38" y2="38">
              <stop offset="0%" stop-color="#e0185c"/>
              <stop offset="55%" stop-color="#5a3ec8"/>
              <stop offset="100%" stop-color="#1e293b"/>
            </linearGradient>
          </defs>
        </svg>
        <div class="logo-text-group">
          <span class="logo-name">Nishwik</span>
          <span class="logo-sub">Hospital OS</span>
        </div>
      </div> -->

      <div class="hero-logo">
        <img
          src="../../assets/images/Logo.svg"
          alt="Nishwik Logo"
          class="img-fluid"
        />
      </div>

    </header>

    <!-- MAIN CONTENT -->
    <main class="main-content">
      <!-- LEFT PANEL -->
      <section class="left-panel">
        <div class="hospital-badge">
          <span class="hospital-badge-dot"></span>
          Hospital Operations Platform
        </div>

        <h1 class="headline">
          Hospital Operations.<br />
          <em>Simplified.</em>
        </h1>

        <p class="subtext">
          Manage patient registration, OPD, IPD, billing, ward activity, doctor
          workflows, and hospital insights all in one connected system. Built
          for every role across your hospital.
        </p>

        <div class="feature-grid">
          <div class="feature-card">
            <div class="fc-icon magenta">
              <i class="fas fa-user-injured"></i>
            </div>
            <div class="fc-text">
              <strong>Patient & OPD</strong>
              <span>Appointments & records</span>
            </div>
          </div>
          <div class="feature-card">
            <div class="fc-icon teal">
              <i class="fas fa-bed"></i>
            </div>
            <div class="fc-text">
              <strong>IPD & Ward</strong>
              <span>Bed allocation & discharge</span>
            </div>
          </div>
          <div class="feature-card">
            <div class="fc-icon purple">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div class="fc-text">
              <strong>Billing & TPA</strong>
              <span>Cashless & pharmacy billing</span>
            </div>
          </div>
          <div class="feature-card">
            <div class="fc-icon orange">
              <i class="fas fa-microscope"></i>
            </div>
            <div class="fc-text">
              <strong>Lab & Radiology</strong>
              <span>Reports & investigations</span>
            </div>
          </div>
        </div>
      </section>

      <!-- RIGHT PANEL -->
      <section class="right-panel">
        <div class="login-card">
          <h2 class="card-title">Welcome Back</h2>
          <!-- <p class="card-subtitle">Please select your role and sign in</p> -->

          <!-- ROLE SELECTOR -->
          <!-- <div class="role-selector mb-4">
            <div *ngFor="let role of roles" 
                 class="role-pill" 
                 [class.active]="loginForm.get('role')?.value === role.value"
                 (click)="loginForm.patchValue({role: role.value})">
              <i [class]="role.icon"></i>
              <span>{{role.label}}</span>
            </div>
          </div> -->

          <!-- PASSWORD LOGIN -->
          <form
            *ngIf="!isMobileLogin"
            [formGroup]="loginForm"
            (ngSubmit)="onLogin()"
          >
            <div class="form-group">
              <label class="form-label">Username / Email</label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter username"
                formControlName="username"
                [class.error]="
                  loginForm.get('username')?.invalid &&
                  loginForm.get('username')?.touched
                "
              />
            </div>

            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label class="form-label">Password</label>
                <!-- <a routerLink="/reset-password/0" class="forgot-link"
                  >Forgot?</a
                > -->
              </div>
              <div class="password-wrap">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="form-control"
                  placeholder="Enter password"
                  formControlName="password"
                  [class.error]="
                    loginForm.get('password')?.invalid &&
                    loginForm.get('password')?.touched
                  "
                />
                <button
                  type="button"
                  class="pwd-toggle"
                  (click)="togglePassword()"
                >
                  <i
                    class="fas"
                    [class.fa-eye]="!showPassword"
                    [class.fa-eye-slash]="showPassword"
                  ></i>
                </button>
              </div>
            </div>

            <div class="form-meta">
              <label class="remember-label">
                <input type="checkbox" /> Remember me
              </label>
            </div>

            <button
              type="submit"
              class="btn-primary"
              [disabled]="loginForm.invalid || loading"
              [class.loading]="loading"
            >
              <span class="btn-text">Sign In</span>
            </button>
          </form>

          <!-- MOBILE LOGIN -->
          <form
            *ngIf="isMobileLogin && !isOtpSent"
            [formGroup]="mobileForm"
            (ngSubmit)="sendOtp()"
          >
            <div class="form-group">
              <label class="form-label">Mobile Number</label>
              <input
                type="tel"
                class="form-control"
                placeholder="Enter 10-digit number"
                formControlName="mobileNo"
                [class.error]="
                  mobileForm.get('mobileNo')?.invalid &&
                  mobileForm.get('mobileNo')?.touched
                "
              />
            </div>
            <button
              type="submit"
              class="btn-primary"
              [disabled]="mobileForm.invalid || loading"
              [class.loading]="loading"
            >
              <span class="btn-text">Send OTP</span>
            </button>
          </form>

          <!-- OTP VERIFICATION -->
          <div *ngIf="isOtpSent" class="otp-section">
            <p class="text-success text-center mb-3 small">
              {{ maskedMessage }}
            </p>
            <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
              <div class="otp-boxes mb-4">
                <input
                  id="otp1"
                  maxlength="1"
                  class="otp-input"
                  formControlName="otp1"
                  (input)="onOtpInput($event, 1)"
                />
                <input
                  id="otp2"
                  maxlength="1"
                  class="otp-input"
                  formControlName="otp2"
                  (input)="onOtpInput($event, 2)"
                />
                <input
                  id="otp3"
                  maxlength="1"
                  class="otp-input"
                  formControlName="otp3"
                  (input)="onOtpInput($event, 3)"
                />
                <input
                  id="otp4"
                  maxlength="1"
                  class="otp-input"
                  formControlName="otp4"
                  (input)="onOtpInput($event, 4)"
                />
                <input
                  id="otp5"
                  maxlength="1"
                  class="otp-input"
                  formControlName="otp5"
                  (input)="onOtpInput($event, 5)"
                />
                <input
                  id="otp6"
                  maxlength="1"
                  class="otp-input"
                  formControlName="otp6"
                  (input)="onOtpInput($event, 6)"
                />
              </div>

              <div
                class="d-flex justify-content-between align-items-center mb-4"
              >
                <span class="timer" *ngIf="timerSeconds > 0"
                  >{{ timerSeconds }}s remaining</span
                >
                <a
                  class="resend-link"
                  [class.disabled]="resendOtpDisabled"
                  (click)="!resendOtpDisabled && resendOtp()"
                  >Resend OTP</a
                >
              </div>

              <button
                type="submit"
                class="btn-primary"
                [disabled]="otpForm.invalid || loading"
                [class.loading]="loading"
              >
                <span class="btn-text">Verify & Login</span>
              </button>

              <div class="text-center mt-3">
                <a class="change-no" (click)="changeMobileNo()"
                  >Change Mobile Number</a
                >
              </div>
            </form>
          </div>

          <!-- <div class="divider">
            <span class="divider-line"></span>
            <span class="divider-text">OR</span>
            <span class="divider-line"></span>
          </div> -->

          <!-- <button type="button" class="btn-otp" (click)="toggleLoginMode()">
            <i
              [class]="isMobileLogin ? 'fas fa-envelope' : 'fas fa-phone-alt'"
            ></i>
            {{ isMobileLogin ? "Login with Password" : "Login via OTP" }}
          </button> -->

          <!-- <div class="card-footer">
            <p class="signup-prompt">
              Don't have an account? <a routerLink="/signup">Sign Up</a>
            </p>
          </div> -->

        </div>
      </section>
    </main>

    <!-- FOOTER -->
    <footer class="bottom-bar">
      <p>&copy; 2026 Nishwik Hospital OS. All rights reserved.</p>
      <div class="bottom-links">
        <a routerLink="/policy/privacy">Privacy Policy</a>
        <a routerLink="/policy/terms">Terms & Conditions</a>
        <a routerLink="/policy/cancellation">Cancellation Policy</a>
        <a routerLink="/policy/refund">Refund Policy</a>
        <a routerLink="/policy/contact">Contact us</a>
      </div>
    </footer>
  </div>
</div>
